<template>
  <div class="simple-header fixed">
      <div class="simple-container">
            <div class="header-left" @click="goBack">
              <el-icon><ArrowLeft /></el-icon>
            </div>
            <div
            class="header-title">{{ title }}</div>
        <div class="header-right"></div>
      </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

defineProps({
  title: {
    type: String,
    default: ''
  }
})

const router = useRouter()

const goBack = () => {
  router.back()
}
</script>

<style scoped>

</style>
